// ── 카테고리 줄의 색 칸 (2026-10-24) — 누르면 색 칩 7개가 펼쳐지고, 고르면 닫힌다 ──
// 사용자: "영화 입력창 색깔창 (누르면 여러가지 컬러칩)". 색은 피드백 옵션과 같은 7색(tones.js), 안 고르면 파랑.
// 작은 펼침 칸이라 화면 스크롤은 잠그지 않는다(모달 규칙 — 드롭다운류). 바깥을 누르면 닫힌다.
import React, { useEffect, useRef, useState } from 'react';
import { FEEDBACK_TONES } from '../../../components/meetingmap/tones';

export function CategoryColorButton({ category, tone, onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, [open]);
  const label = FEEDBACK_TONES.find((t) => t.key === tone)?.label || '파랑';
  return (
    <div ref={ref} className="relative shrink-0">
      <button
        type="button" aria-haspopup="listbox" aria-expanded={open} aria-label={`${category} 마커 색 (${label})`}
        onClick={() => setOpen((v) => !v)}
        className="flex h-7 items-center gap-1 rounded-md border border-[var(--border)] bg-[var(--bg-card)] px-1.5"
      >
        <span className="h-4 w-4 rounded-full" style={{ background: `var(--mm-tone-${tone}-solid-bg)` }} />
        <span className="text-[10px] text-[var(--text-muted)]">▾</span>
      </button>
      {open && (
        <div
          role="listbox" aria-label={`${category} 색 고르기`}
          className="absolute right-0 top-[calc(100%+4px)] z-20 grid w-max grid-cols-4 gap-1.5 rounded-lg border border-[var(--border)] bg-[var(--bg-card)] p-2 shadow-lg"
        >
          {FEEDBACK_TONES.map((t) => (
            <button
              key={t.key} type="button" role="option" aria-selected={tone === t.key} title={t.label} aria-label={t.label}
              onClick={() => { onPick(t.key); setOpen(false); }}
              className={`flex h-7 w-7 items-center justify-center rounded-full border-2 ${
                tone === t.key ? 'border-slate-900 dark:border-white' : 'border-transparent'}`}
            >
              <span className="h-5 w-5 rounded-full" style={{ background: `var(--mm-tone-${t.key}-solid-bg)` }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
